module.exports = __webpack_public_path__ + "media/images/badge-fullcolor-alpha__300x300-f4b785253a6b71c4ec3db06727cd05e3.png";